import { Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';
import { Observable, of } from 'rxjs';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { AlertService } from 'src/app/services/alert.service';
import { AuthService } from 'src/app/services/auth.service';
import { SwiperContainer } from 'swiper/element';

export const ONGOING_LOGIN_SESSION_INFO = 'ONGOING_LOGIN_SESSION_INFO';

@Component({
  selector: 'app-home',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.scss', '../authentication.scss']
})
export class HomePage implements OnInit {
  viewModel$: Observable<any> = of({
    title: "Welcome",
    loginButtonText: "Already Registered",
    registerButtonText: "Register"
  });

  @ViewChild('slides') slides!: SwiperContainer;

  //theme: string;
  selectedCountryCode: string = "au";
  selectedLanguageName: string = "english";
  pendingSession: { page: string, phone?: string, singleUseRegistrationPassword?: string, siteCode?: string, locale?: string } | null = null;

  constructor(
    private docTitle: Title,
    private modalCtrl: ModalController,
    private analyticsService: AnalyticsService,
    private alertService: AlertService,
    private router: Router,
    private authService: AuthService,
  ) {
    this.viewModel$.subscribe(vm => this.docTitle.setTitle(vm.title));
    this.analyticsService.tagRoute('unauthenticated/home');
    // this.theme = this.brandProvider.get();
    // this.selectedCountryCode = this.global.getCountryCode();
    // this.selectedLanguageName = SUPPORTED_LOCALES_MAP[this.global.language];
  }

  ngOnInit() {
    try {
      this.checkForPendingCodeVerification();
    } catch(e) {
      console.error(e);
    }
  }

  async checkForPendingCodeVerification() {
    try {
      await this.authService.getCurrentUser();
    } catch (err: any) {
      const sessionData = JSON.parse((await SecureStoragePlugin.get({ key: ONGOING_LOGIN_SESSION_INFO }).catch(() => {}))?.value ?? '{}') as { page: string, phone?: string, singleUseRegistrationPassword?: string, siteCode?: string, locale?: string };
      if (sessionData.page) {
        this.pendingSession = sessionData;
      }
    }
  }

  resumePendingSession() {
    if (!this.pendingSession) return;
    const { page, phone, singleUseRegistrationPassword, siteCode, locale } = this.pendingSession;
    if (page === 'verifysignup' && singleUseRegistrationPassword) {
      this.authService.singleUseRegistrationPassword = singleUseRegistrationPassword;
    }
    const queryParams: Record<string, string> = {};
    if (phone) queryParams['phone'] = phone;
    if (siteCode) queryParams['siteCode'] = siteCode;
    if (locale) queryParams['locale'] = locale;
    this.router.navigate(['unauthenticated', page], { queryParams });
  }

  goToRegister() {
    this.analyticsService.tagButtonPress('home_page', 'register');
    if (this.pendingSession && this.pendingSession.page !== 'verifylogin') {
      this.alertService.confirm(
        'Pending Registration',
        'You have an unfinished registration. Would you like to continue from where you left off?',
        'Continue',
        () => this.resumePendingSession(),
        'Start Over',
        () => this.router.navigate(['unauthenticated', 'siteCodeEntry'])
      );
    } else {
      this.router.navigate(['unauthenticated', 'siteCodeEntry']);
    }
  }

  goToLogin() {
    this.analyticsService.tagButtonPress('home_page', 'login');
    this.router.navigate(['unauthenticated', 'login']);
  }

  async nextSlide() {
    if (await this.slides.swiper.isEnd) {
      this.slides.swiper.slideTo(0);
    } else {
      this.slides.swiper.slideNext();
    }
  }

  async prevSlide() {
    if (await this.slides.swiper.isBeginning) {
      this.slides.swiper.slideTo(this.slides.swiper.slides.length - 1);
    } else {
      this.slides.swiper.slidePrev();
    }
  }

  // openLanguageSelectorModal() {
  //   const languageSelectorModal = this.modalCtrl.create(
  //     'LanguageSelectorModalPage',
  //   );
  //   languageSelectorModal.onDidDismiss(data => {
  //     this.selectedCountryCode = this.global.getCountryCode();
  //     this.selectedLanguageName = SUPPORTED_LOCALES_MAP[this.global.language];
  //     if (data && data.preferredLanguage) {
  //       this.storageService.set('loggedOutLanguage', data.preferredLanguage);
  //     }
  //   });
  //   languageSelectorModal.present();
  // }


  enableSliderControls() {
    return true;
  }
}
